import configureStore from "./configureStore";

const reduxConfigStore = configureStore();

export default reduxConfigStore
